<template>
  <a-modal v-model="modal" title="批量修改" width="500px" :maskClosable="false" :closable="false">
    <a-form-model
      :model="formData"
      ref="form"
    >
      <a-form-model-item
        label="调拨到仓日期"
        :labelCol="{ style: 'width: 120px;float:left' }"
        :wrapperCol="{ style:'width:calc(100% - 120px );float:left'}"
        prop="deliveryDate"
        :rules="rules.deliveryDate"
      >
        <a-date-picker style="width:100%" v-model="formData.deliveryDate" @change="changeDate" :disabled-date="disabledEndDate" />
      </a-form-model-item>
    </a-form-model>
    <template #footer>
      <a-space>
        <a-button :loading="loading" @click="modal=false;$refs.form.resetFields();">取消</a-button>
        <a-button type="primary" @click="submit" :loading="loading">确定</a-button>
      </a-space>
    </template>
  </a-modal>
</template>

<script>
import {
  apiInvWipAllocationPlanDispatchBatchUpdate
} from '@/api/mes/scheduling-plan/sub-warehouse-plan'

export default {
  name: 'BatchEditDeliveryDateModal',
  data() {
    return {
      modal: false,
      formData: {
        deliveryDate: ""
      },
      loading: false,
      rules: {
        deliveryDate: [{ required: true, message: ' ', trigger: 'change' }]
      },
      selectedRows: []
    }
  },
  methods: {
    show (list) {
      this.selectedRows = list
      this.formData.deliveryDate = ""
      this.modal = true
    },
    submit () {
      this.$refs.form.validate(valid => {
        if(valid) {
          this.loading = true;
          const lineIds = this.selectedRows.map(item => item.lineId)
          const params = {
            lineIds,
            deliveryDate: this.formData.deliveryDate
          }
          apiInvWipAllocationPlanDispatchBatchUpdate(params).then(response => {
            if (response.code === 200) {
              this.modal = false
              this.$message.success('修改完成!')
              this.$emit("click")
            } else {
              this.$message.error(response.msg)
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    // 修改到货日期
    changeDate (val) {
      this.formData.deliveryDate = this.momentFun(val)
    },
    disabledEndDate (date) {
      return date && date.valueOf() < Date.now() - 86400000;
    }
  }
}
</script>

<style scoped>

</style>
